import React from 'react'
import {
  type CardInformativeScopedProps,
  DISPLAY_NAME,
  useCardInformativeContext,
} from '../../card-informative'
import { CardInformativeTitle } from '../card-informative-title'
import { CardInformativeContentVariants } from './card-informative-content.styles'

type CardInformativeContentProps = {
  children: React.ReactNode
}

export const CardInformativeContent = (props: CardInformativeContentProps) => {
  const { children, __scopeCardInformative } =
    props as CardInformativeScopedProps<CardInformativeContentProps>
  const { type } = useCardInformativeContext(
    DISPLAY_NAME,
    __scopeCardInformative
  )

  return (
    <div {...props} className={CardInformativeContentVariants({})}>
      {React.Children.map(children, child => {
        if (!React.isValidElement(child)) return child

        if (type !== 'highlight' && child.type === CardInformativeTitle) {
          return null
        }

        return child
      })}
    </div>
  )
}
